import { breakpointValues, Button, PartialOutageError, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import UFOLoadHold from '@atlassian/ufo-load-hold';
import React from 'react';
import { AppTileGridSkeleton, AppTilesGridContainer } from '../../primitives';
import { ButtonContainer, ErrorContainer, GridFooterContainer, InitialFetchErrorContainer } from './PaginatedAppGrid.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Replace with actual error UI
const InitialFetchError = () => /*#__PURE__*/_jsx(InitialFetchErrorContainer, {
  children: /*#__PURE__*/_jsx(PartialOutageError, {})
});
const FetchMoreError = () => /*#__PURE__*/_jsx(ErrorContainer, {
  children: /*#__PURE__*/_jsx(PartialOutageError, {
    level: "tile"
  })
});
export const PaginatedAppGrid = _ref => {
  let {
    renderGrid,
    isLoading,
    isLoadingMore,
    onLoadMoreClick,
    showLoadMoreButton,
    fetchMoreError,
    initialFetchError,
    desktopColumns = 3,
    tabletColumns = 2,
    mobileColumns = 1
  } = _ref;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const loadingMoreTileCount = breakpoint < breakpointValues.md ? tabletColumns : desktopColumns;
  if (initialFetchError) {
    return /*#__PURE__*/_jsx(InitialFetchError, {});
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(AppTilesGridContainer, {
      desktopColumns: desktopColumns,
      tabletColumns: tabletColumns,
      mobileColumns: mobileColumns,
      children: [isLoading ? /*#__PURE__*/_jsx(UFOLoadHold, {
        name: "app-tile",
        children: /*#__PURE__*/_jsx(AppTileGridSkeleton, {
          tileCount: desktopColumns * 2
        })
      }) : renderGrid(), isLoadingMore && /*#__PURE__*/_jsx(AppTileGridSkeleton, {
        tileCount: loadingMoreTileCount
      })]
    }), /*#__PURE__*/_jsxs(GridFooterContainer, {
      children: [fetchMoreError && /*#__PURE__*/_jsx(FetchMoreError, {}), showLoadMoreButton && /*#__PURE__*/_jsx(ButtonContainer, {
        children: /*#__PURE__*/_jsx(Button, {
          isLoading: isLoadingMore,
          onClick: onLoadMoreClick,
          "aria-label": "Load more apps",
          children: "Load more"
        })
      })]
    })]
  });
};